'use strict';

var React = require('react');

var SvgAnalyticsDonutMinor = function SvgAnalyticsDonutMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.938 9.003c.068.547-.386.997-.938.997a7 7 0 1 1-7-7v1.5a5.5 5.5 0 1 0 5.5 5.5h-2.5a3 3 0 1 1-3-3v-4c0-.552.45-1.007.997-.938a8 8 0 0 1 6.94 6.94Zm-1.613-.503a6.503 6.503 0 0 0-4.825-4.825v3.612a3.099 3.099 0 0 1 1.213 1.213h3.612Zm-6.325 3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
  }));
};
SvgAnalyticsDonutMinor.displayName = "AnalyticsDonutMinor";

exports.SvgAnalyticsDonutMinor = SvgAnalyticsDonutMinor;
